// @ts-nocheck
import mitt from 'mitt';
import Router from 'next/router';

const emitter = mitt();
Router.onRouteChangeStart = url => emitter.emit('routeChangeStart', url);
Router.onRouteChangeComplete = url => emitter.emit('routeChangeComplete', url);
Router.onRouteChangeError = (err, url) => emitter.emit('routeChangeError', { err, url });

export default emitter;
